// extracted by mini-css-extract-plugin
export default {"notificationContainer":"Ej3XSVnK5D5EzH4LW_KQ","logo":"a67AgZybYisHRGbnKoxs","on":"OUBm2tTiHEi_kVazvKpf","off":"bepyxvMEiQ7ivr23QiXV"};